import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left side */}
        <div className="footer-brand">
          <h2><i className="fa-solid fa-broom"></i> Cleanering</h2>
          <p>
            Connecting verified cleaning experts with homes, offices, and
            businesses. Reliable, affordable, and available near you.
          </p>
          <div className="footer-socials">
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <a href="#"><i className="fa-brands fa-facebook"></i></a>
            <a href="#"><i className="fa-brands fa-instagram"></i></a>
            <a href="#"><i className="fa-brands fa-x-twitter"></i></a>
            <a href="#"><i className="fa-brands fa-linkedin"></i></a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="#">About</a></li>
            <li><a href="#">Contact</a></li>
          </ul>
        </div>

        {/* Contact Info */}
       
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Cleanering. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;